import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { GunningsComponent } from "src/app/sections/gunnings/gunnings.component";

import { SharedModuleModule } from "../shared-module/shared-module.module";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { MaterialModule } from "../material/material.module";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DataTablesModule } from "angular-datatables";
import { GunningsModalComponent } from "src/app/sections/gunnings/modal/gunnings-modal.component";
import { PlotlyModule } from "angular-plotly.js";

@NgModule({
  declarations: [GunningsComponent],
  imports: [
    CommonModule,
    SharedModuleModule,
    PlotlyModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    DataTablesModule,
  ],
  exports: [GunningsComponent],
})
export class GunningsModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
